import { type PayPalCheckoutCreatePaymentOptions } from 'braintree-web';
import {
  type ButtonLabelOption,
  type ButtonStyle,
  type Environment,
} from 'paypal-checkout-components';

export const PROCESSOR_NAMES = {
  STRIPE: 'stripe',
  BRAINTREE: 'braintree',
} as const;

export const PAYMENT_TYPES = {
  CREDIT_CARD: 'card',
  PAYPAL: 'paypal',
  APPLE_PAY: 'apple-pay',
} as const;

export const DISPLAY_PAYMENT_TYPES = {
  AMERICAN_EXPRESS: 'American Express',
  APPLE_PAY: 'apple-pay',
  DINERS_CLUB: 'Diners Club',
  DISCOVER: 'Discover',
  JCB: 'JCB',
  MASTERCARD: 'MasterCard',
  PAYPAL: 'paypal',
  UNION_PAY: 'UnionPay',
  VISA: 'Visa',
  VISA_LEGACY: 'visa',
} as const;

export const PAYMENT_LINE_ITEM_LABELS = {
  AGENCY_TOTAL: 'Agency',
  CUROLOGY_TOTAL: 'Curology, inc.',
  DISCOUNT: 'Discount',
  SHIPPING: 'Shipping',
  HANDLING: 'Handling fee',
  TAX: 'Tax',
  PURCHASE_SUBTOTAL: 'Your box',
  TRIAL_PURCHASE_SUBTOTAL: '30-day trial box',
  TRIAL_PURCHASE_SHIPPING_OPTION: 'Ground Shipping',
  TRIAL_PURCHASE_FUTURE_SUBTOTAL: 'Your next box',
} as const;

/**
 * These constants have specific Enum types in `braintree-web` that are not readily accessible.
 * Import the typed constants to assist in writing type-safe code around `braintree-web`.
 *
 * @see node_modules/@types/braintree-web/modules/paypal-checkout.d.ts
 */
const RECT = 'rect' as ButtonStyle['shape'];
const PILL = 'pill' as ButtonStyle['shape'];
const RESPONSIVE = 'responsive' as ButtonStyle['size'];

const PAY = 'pay' as ButtonLabelOption.Pay;
const PAYPAL = 'paypal' as ButtonLabelOption.PayPal;

const PRODUCTION = 'production' as Environment;
const SANDBOX = 'sandbox' as Environment;

const VAULT = 'vault' as NonNullable<
  PayPalCheckoutCreatePaymentOptions['flow']
>;
const AUTHORIZE = 'authorize' as NonNullable<
  PayPalCheckoutCreatePaymentOptions['intent']
>;

export const PAYPAL_CONSTANTS = {
  AUTHORIZE,
  RECT,
  PILL,
  RESPONSIVE,
  PAY,
  PAYPAL,
  PRODUCTION,
  SANDBOX,
  VAULT,
};
